<mat-slide-toggle
    [ngModelOptions]="{ standalone: true }"
    [(ngModel)]="active"
    (change)="toggleEnhancedHelp()">
    Enhanced Help
</mat-slide-toggle>
